import React from "react";
import { Backdrop, CircularProgress, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  solid: {
    color: "#286f8c",
    background: "#28aecb",
  },
  transparent: {
    color: "white",
    margin: "0 !important",
    zIndex: 1001,
  },
  logo: {
    width: 200,
  },
}));

const LoadingIndicator = ({ transparent }) => {
  const classes = useStyles();
  return (
    <Backdrop
      className={transparent ? classes.transparent : classes.solid}
      open={true}
    >
      <Grid
        container
        spacing={1}
        direction="column"
        alignContent="center"
        alignItems="center"
      >
        <Grid item>
          <CircularProgress color="inherit" />
        </Grid>
      </Grid>
    </Backdrop>
  );
};

export default LoadingIndicator;
